module.exports = __webpack_public_path__ + "static/media/rabbit4.25acce1b.png";